import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "@/components/site/primitives";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export const Pricing = ({ onChoose }) => {
  const { t } = useLang();
  return (
    <section id="readings" className="relative py-28 sm:py-36 bg-espresso/30 border-y border-gold/10" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>{t.offers.eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display font-light text-sand text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
            {t.offers.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6 items-stretch">
          {t.offers.cards.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.1} className="h-full">
              <div
                className={`group relative h-full flex flex-col rounded-2xl border p-8 transition-all duration-500 hover:-translate-y-2 ${
                  c.featured
                    ? "border-gold/60 bg-gradient-to-b from-espresso to-ivy shadow-[0_0_60px_-15px_rgba(194,164,107,0.35)]"
                    : "border-gold/20 bg-ivy/40 hover:border-gold/40"
                }`}
                data-testid={`pricing-card-${c.id}`}
              >
                {c.featured && (
                  <span className="absolute -top-3 left-8 bg-gold text-espresso text-[10px] font-serifluxe tracking-widest uppercase px-3 py-1 rounded-full">
                    ★
                  </span>
                )}
                <div className="text-gold text-3xl">{c.glyph}</div>
                <h3 className="mt-5 font-editorial italic text-sand text-2xl sm:text-3xl">{c.t}</h3>
                <div className="mt-4 flex items-baseline gap-2 flex-wrap">
                  {c.pricePrefix && <span className="text-sand/60 text-sm">{c.pricePrefix}</span>}
                  {c.priceWas && <span className="text-sand/40 line-through text-xl">{c.priceWas}</span>}
                  <span className="font-display text-gold text-4xl sm:text-5xl">{c.price}</span>
                </div>

                <ul className="mt-7 space-y-3 flex-1">
                  {c.feats.map((f, j) => (
                    <li key={j} className="flex items-start gap-3 text-sand/80 text-sm font-light">
                      <Check size={16} className="text-gold mt-0.5 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>

                <p className="mt-5 text-sand/50 text-sm italic leading-relaxed">{c.note}</p>

                <Button
                  onClick={() => onChoose(c.id)}
                  className={`mt-6 w-full rounded-full h-11 font-body tracking-wide transition-transform hover:scale-[0.98] ${
                    c.featured
                      ? "bg-gold hover:bg-gold/90 text-espresso"
                      : "bg-transparent border border-gold/50 text-sand hover:bg-gold/10"
                  }`}
                  data-testid={`pricing-choose-${c.id}`}
                >
                  {t.offers.choose}
                </Button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
